

























import AppModal from '@/components/AppModal.vue'
import AppButton from '@/components/AppButton.vue'
import { MapFactoryController } from '../lib/map'
import { createComponent, ref, inject, reactive } from '@vue/composition-api'
import { MainMapControllerSymbol } from '../symbols'
import { FactoryStatusText, FactoryStatus, FACTORY_STATUS_ITEMS } from '../types'

export default createComponent({
  name: 'FilterModal',
  components: {
    AppModal,
    AppButton
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    dismiss: {
      type: Function
    }
  },
  setup (props) {
    const filters = reactive({
      [FactoryStatus.NEW]: true,
      [FactoryStatus.EXISTING_INCOMPLETE]: true,
      [FactoryStatus.EXISTING_COMPLETE]: true,
      [FactoryStatus.REPORTED]: true
    })

    const mapController = inject(MainMapControllerSymbol, ref<MapFactoryController>())

    return {
      filters,
      onClick () {
        if (!mapController.value) {
          return
        }

        const statusTypes = Object.entries(filters)
          .map(([key, value]) => value ? key : false)
          .filter(Boolean) as FactoryStatus[]

        mapController.value.setFactoryStatusFilter(statusTypes)

        if (typeof props.dismiss === 'function') {
          props.dismiss()
        }
      },
      FACTORY_STATUS_ITEMS,
      FactoryStatus,
      FactoryStatusText
    }
  }
})
